import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from '../../services/translate/translate.service';
import { RS_NULL_DASH } from '../../constants/null-dash';

@Pipe({
  name: 'rsCurrency',
  pure: false
})
export class RsCurrencyPipe implements PipeTransform {
  private readonly currentLang = inject(TranslationService).currentLang;

  public transform(value: number | undefined | null): string {
    const formatter = new Intl.NumberFormat(this.currentLang(), { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return value == null ? RS_NULL_DASH : `€ ${formatter.format(value)}`;
  }
}
